import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageManagementTaskDTO, SaveImageTaskDTO } from 'business/models/Models';
import ImageManagementTaskService from 'business/services/ImageManagementTaskService';

export const getImageManagementTasks = createAsyncThunk(
  'getImageManagementTasks',
  async () => {
    const dataService = new ImageManagementTaskService();
    return await dataService.getAllImageManagementTasks();
  },
);

export const saveImageManagementTasks = createAsyncThunk(
  'saveImageManagementTasks',
  async (saveImageTaskDTO: SaveImageTaskDTO, thunkApi) => {
    const dataService = new ImageManagementTaskService();
    return await dataService.save(saveImageTaskDTO);
  },
);
export const startImageManagementTasks = createAsyncThunk(
  'startImageManagementTasks',
  async (payload: StartImageManagementTaskPayload, thunkApi) => {
    const dataService = new ImageManagementTaskService();
    return await dataService.start(payload.startImageTaskDTO, payload.disableProgress);
  },
);
export type StartImageManagementTaskPayload = {
  startImageTaskDTO: ImageManagementTaskDTO;
  disableProgress: boolean;
};
